import type { AssetResponse } from '@on3/api';
import { useSite } from '@on3/ui-lib/index';
import { ResizedImage } from 'components/Image/ResizedImage';
import { Forums } from 'components/Svg/Forums';
import { Text } from 'components/UI/Typography/Text';

import styles from './JoinForumMarketing.module.scss';

interface IJoinForumMarketingProps {
  forumsTitle?: string | null;
  primaryForumTitle?: string | null;
  description?: string | null;
  assetOne?: AssetResponse;
  assetTwo?: AssetResponse;
}
export const JoinForumMarketing = ({
  primaryForumTitle,
  forumsTitle,
  description,
  assetOne,
  assetTwo,
}: IJoinForumMarketingProps) => {
  const { currentSite } = useSite();
  const primaryColor = currentSite?.primaryColor || '#FE3B1F';

  return (
    <section className={styles.forumMarketingSection}>
      <header>
        <Text className={styles.title} variant="h1">
          {forumsTitle}
        </Text>
      </header>
      <div className={styles.contentWrapper}>
        <div className={styles.descriptionContainer}>
          <Text className={styles.forumSubHeader} variant="subtitle1">
            Message Boards
          </Text>
          <div className={styles.primaryForumTitleWrapper}>
            <Forums fill={primaryColor} height={18} width={18} />
            <Text className={styles.primaryForum} variant="h3">
              {primaryForumTitle}
            </Text>
          </div>
          {description && (
            <div
              className={styles.description}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </div>
        <div className={styles.assetContainer}>
          <ResizedImage
            {...assetOne}
            fit="cover"
            gravity="0.5x0.5"
            height={285}
            quality={90}
            width={150}
          />

          <ResizedImage
            {...assetTwo}
            fit="cover"
            gravity="0.5x0.5"
            height={285}
            quality={90}
            width={400}
          />
        </div>
      </div>
    </section>
  );
};
